import React from 'react';
import { GameLayout } from './GameLayout';

export const Game = () => {
    return <GameLayout />;
};
